export enum OnboardingStatus {
  CANCELED = 'canceled',
  SESSION_CREATED = 'session_created',
  COMPANY_SAVED = 'company_saved',
  CONSENT_GRANTED = 'consent_granted',
  PENDING_SALES = 'pending_sales',
  PLAN_SELECTED = 'plan_selected',
  PAYMENT_PENDING = 'payment_pending',
  PAYMENT_CONFIRMED = 'payment_confirmed',
  COMPLETED = 'completed',
}

export function onboardingStatusRank(status: OnboardingStatus): number {
  const ranks: Record<OnboardingStatus, number> = {
    [OnboardingStatus.CANCELED]: -1,
    [OnboardingStatus.SESSION_CREATED]: 0,
    [OnboardingStatus.COMPANY_SAVED]: 1,
    [OnboardingStatus.CONSENT_GRANTED]: 2,
    [OnboardingStatus.PENDING_SALES]: 2,
    [OnboardingStatus.PLAN_SELECTED]: 3,
    [OnboardingStatus.PAYMENT_PENDING]: 4,
    [OnboardingStatus.PAYMENT_CONFIRMED]: 5,
    [OnboardingStatus.COMPLETED]: 6,
  };

  return ranks[status];
}
